"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Order = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _classnames2 = _interopRequireDefault(require("classnames"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _book = require("../../../../../routes/book");
var _price = require("../../../../../../helpers/price");
var _fn = require("../../../../../../helpers/fn");
var _config = require("../../../../../../services/config");
var _external = require("../../../../../../bus/external");
var _actions = require("../../../../../../modalDispatcher/store/actions");
var _ConfirmModal = require("../../../../../ConfirmModal");
var _Badge = _interopRequireDefault(require("../../../../../ui/Badge"));
var _Button = _interopRequireWildcard(require("../../../../../ui/Button"));
var _Dropdown = require("../../../../../ui/Dropdown");
var _Alert = _interopRequireWildcard(require("../../../../../ui/Alert"));
var _BasketButtons = _interopRequireDefault(require("../../../Offer/Buttons/components/BasketButtons"));
var _CopyInfoButton = _interopRequireDefault(require("../../../Offer/Buttons/components/CopyInfoButton"));
var _SaveOrderButton = _interopRequireDefault(require("../../../Offer/Buttons/components/SaveOrderButton"));
var _Divider = require("../../../../../ui/Divider");
var _selectors = require("../../store/selectors");
var _BookingServices = require("../BookingServices");
var _BookingInfoOfReservation = require("../BookingInfoOfReservation");
var _ScheduleBookingPayments = require("../ScheduleBookingPayments");
var _actions2 = require("./store/actions");
var _OperatorDetails = require("./components/OperatorDetails");
var _OperatorLink = require("./components/OperatorLink");
var _OperatorRateOfConfirmation = require("./components/OperatorRateOfConfirmation");
var _OperatorCode = require("./components/OperatorCode");
var _DefaultBookingButton = require("./components/DefaultBookingButton");
var _BookingButton = require("./components/BookingButton");
var _LoginRequestButton = require("./components/LoginRequestButton");
var _helpers = require("./helpers");
var _styles = _interopRequireDefault(require("./styles"));
var _yes = _interopRequireDefault(require("./img/yes.svg"));
var _no = _interopRequireDefault(require("./img/no.svg"));
var _copy = _interopRequireDefault(require("./img/copy.svg"));
var _share = _interopRequireDefault(require("./img/share.svg"));
var _diez = _interopRequireDefault(require("./img/diez.svg"));
var _newWindow = _interopRequireDefault(require("./img/new-window.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var mapperWithIndex = R.addIndex(R.map);
var OrderPure = function OrderPure(_ref) {
  var actualizedAdditionalPayments = _ref.actualizedAdditionalPayments,
    actualizedIsHeightPromo = _ref.actualizedIsHeightPromo,
    actualizedPrice = _ref.actualizedPrice,
    actualizedPromoText = _ref.actualizedPromoText,
    additionalPayments = _ref.additionalPayments,
    className = _ref.className,
    countryID = _ref.countryID,
    currency = _ref.currency,
    hotelID = _ref.hotelID,
    includes = _ref.includes,
    isActualized = _ref.isActualized,
    isActualLastUpdate = _ref.isActualLastUpdate,
    isConnectionFailedWithOperator = _ref.isConnectionFailedWithOperator,
    isEndActualized = _ref.isEndActualized,
    isHeightPromo = _ref.isHeightPromo,
    message = _ref.message,
    lastUpdateTime = _ref.lastUpdateTime,
    offerID = _ref.offerID,
    offerKey = _ref.offerKey,
    operator = _ref.operator,
    price = _ref.price,
    promoText = _ref.promoText,
    requirements = _ref.requirements,
    subOperatorName = _ref.subOperatorName,
    queryID = _ref.queryID,
    onBooking = _ref.onBooking;
  var operatorID = operator === null || operator === void 0 ? void 0 : operator.id;
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return operator ? (0, _external.getBookingTypes)(state, {
        operatorID: operatorID
      }) : {};
    }),
    _useSelector$isBookin = _useSelector.isBookingByOperator,
    isBookingByOperator = _useSelector$isBookin === void 0 ? true : _useSelector$isBookin,
    _useSelector$isBookin2 = _useSelector.isBookingByOwn,
    isBookingByOwn = _useSelector$isBookin2 === void 0 ? false : _useSelector$isBookin2;
  var openedInModalByKey = (0, _reactRedux.useSelector)(_selectors.getOpenedInModalByKey);
  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
      return operator ? (0, _external.getBookingOperatorById)(state, {
        operatorID: operatorID
      }) : false;
    }),
    rateOfConfirmation = _useSelector2.rateOfConfirmation,
    enabledLoginRequest = _useSelector2.enabledLoginRequest;
  var recalculatedOfferPrice = (0, _reactRedux.useSelector)(function (state) {
    return (0, _BookingServices.getRecalculatedOfferPrice)(state, {
      currency: currency.code
    });
  });
  var totalPriceOfBookingServices = (0, _reactRedux.useSelector)(function (state) {
    return (0, _BookingServices.getTotalPriceOfBookingServices)(state, {
      offerID: offerID,
      currency: currency.code
    });
  });
  var isEnabledAdd2Basket = (0, _reactRedux.useSelector)(_selectors.getIsEnabledAdd2Basket);
  var isEnabledSave2Order = (0, _reactRedux.useSelector)(_selectors.getIsEnabledSave2Order);
  var isEnabledCopy2Buffer = (0, _reactRedux.useSelector)(_selectors.getIsEnabledCopy2Buffer);
  var isEnabledCopyURL2Buffer = (0, _reactRedux.useSelector)(_selectors.getIsEnabledCopyURL2Buffer);
  var _useTranslation = (0, _reactI18next.useTranslation)('OFFER_DETAILS', 'CONFIRM_MODAL'),
    t = _useTranslation.t;
  var dispatch = (0, _reactRedux.useDispatch)();
  var handleClickByBookingButton = (0, _react.useCallback)(function () {
    dispatch((0, _actions2.showBookingForm)(offerID, hotelID, onBooking));
  }, [dispatch, hotelID, offerID, onBooking]);
  var onCopyOfferURL = (0, _react.useCallback)(function () {
    var callback = R.or((0, _config.getOnCopyOfferURLToBuffer)(), function (offerURL) {
      return Promise.resolve(offerURL);
    });
    (0, _fn.copyToBufferDynamicContent)(function () {
      var offerURL = R.concat(global.location.origin, (0, _reactRouter.generatePath)(_book.book.offer, {
        hotelID: hotelID,
        offerID: offerID
      }));
      return callback(offerURL, {
        currency: currency.code
      });
    });
    dispatch((0, _ConfirmModal.showConfirmModal)(undefined, {
      header: t('SUCCESS_HEADER_FOR_COPIED_LINK'),
      confirmButtonText: t('OK'),
      cancelButton: false
    }));
  }, [currency, dispatch, hotelID, offerID, t]);
  var onSuccessSavedOfferToBasket = (0, _react.useCallback)(function () {
    dispatch((0, _actions.close)(openedInModalByKey));
    dispatch((0, _actions.destroy)(openedInModalByKey));
  }, [dispatch, openedInModalByKey]);
  var onCopyOfferCode = (0, _react.useCallback)(function () {
    (0, _fn.copyToBuffer)(offerID);
    dispatch((0, _ConfirmModal.showConfirmModal)(undefined, {
      header: t('SUCCESS_HEADER_FOR_COPIED_TOUR_CODE'),
      confirmButtonText: t('OK'),
      cancelButton: false
    }));
  }, [dispatch, offerID, t]);
  var onOpenOffer = (0, _react.useCallback)(function () {
    var offerURL = R.concat(global.location.origin, (0, _reactRouter.generatePath)(_book.book.offer, {
      hotelID: hotelID,
      offerID: offerID
    }));
    global.open(offerURL, '_blank');
  }, [hotelID, offerID]);
  var shouldRenderBasketButton = isEnabledAdd2Basket && (isActualized || isActualLastUpdate);
  var promoBadge = (0, _react.useMemo)(function () {
    return R.apply(_helpers.createPromoBadge, actualizedPrice ? [actualizedIsHeightPromo, actualizedPromoText] : [isHeightPromo, promoText]);
  }, [actualizedIsHeightPromo, actualizedPrice, actualizedPromoText, isHeightPromo, promoText]);
  var infoList = (0, _react.useMemo)(function () {
    return R.filter(Boolean, [(0, _helpers.createMoldovaResidentsInfoItem)(includes), (0, _helpers.createAdditionalPaymentInfoItem)(actualizedPrice ? actualizedAdditionalPayments : additionalPayments), (0, _helpers.createRequirementGalaDinnerInfoItem)(requirements)]);
  }, [actualizedAdditionalPayments, actualizedPrice, additionalPayments, includes, requirements]);
  var isOldPrice = isEndActualized && !isActualized && !isConnectionFailedWithOperator;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)(_styles.default.list, className)
  }, !R.isEmpty(infoList) && /*#__PURE__*/_react.default.createElement(_Alert.default, {
    type: _Alert.TYPES.DANGER
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: _styles.default.infoList
  }, mapperWithIndex(function (infoItem, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index
    }, infoItem.content);
  }, infoList))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)(_styles.default.item, _defineProperty(_defineProperty(_defineProperty({}, _styles.default.oldPrice, isOldPrice), _styles.default.actualPrice, isActualLastUpdate || isActualized), _styles.default.grayscalePrice, isEndActualized && isConnectionFailedWithOperator))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.price
  }, price && (0, _price.preparePriceForRender)(isOldPrice ? price : (0, _helpers.combineOfferPrices)(price, recalculatedOfferPrice, totalPriceOfBookingServices), currency.symbol), !actualizedPrice && promoBadge && /*#__PURE__*/_react.default.createElement(_Badge.default, promoBadge)), isActualLastUpdate ? /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.priceDesc
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.priceIcon,
    dangerouslySetInnerHTML: {
      __html: _yes.default
    }
  }), t('PRICE_ACTUALIZED_BY_TIME', {
    time: (0, _moment.default)(lastUpdateTime).format('HH:mm')
  })) : isEndActualized && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.priceDesc
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.priceIcon,
    dangerouslySetInnerHTML: {
      __html: isConnectionFailedWithOperator || isActualized ? _yes.default : _no.default
    }
  }), message && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !isActualized && !isConnectionFailedWithOperator && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, t('PRICE_NOT_ACTUAL'), ":", /*#__PURE__*/_react.default.createElement("br", null)), message)), rateOfConfirmation && !(0, _config.isTouristMode)() && /*#__PURE__*/_react.default.createElement(_OperatorCode.OperatorCode, {
    subOperatorName: subOperatorName,
    onCopyOfferURL: onCopyOfferURL
  })), actualizedPrice && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)(_styles.default.item, _styles.default.actualPrice)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.price
  }, (0, _price.preparePriceForRender)((0, _helpers.combineOfferPrices)(actualizedPrice, recalculatedOfferPrice, totalPriceOfBookingServices), currency.symbol), promoBadge && /*#__PURE__*/_react.default.createElement(_Badge.default, promoBadge)), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.priceDesc
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.priceIcon,
    dangerouslySetInnerHTML: {
      __html: _yes.default
    }
  }), message)), !(0, _config.isTouristMode)() && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.operatorAndCode
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.operator
  }, operator ? /*#__PURE__*/_react.default.createElement(_OperatorLink.OperatorLink, {
    countryID: countryID,
    isBookingByOperator: isBookingByOperator,
    logo: operator.logo,
    name: operator.name,
    offerID: offerID,
    operatorID: operator.id
  }) : t('OPERATOR_IS_UNKNOWN')), rateOfConfirmation ? /*#__PURE__*/_react.default.createElement(_OperatorRateOfConfirmation.OperatorRateOfConfirmation, {
    className: _styles.default.operatorRate,
    rate: rateOfConfirmation
  }) : /*#__PURE__*/_react.default.createElement(_OperatorCode.OperatorCode, {
    subOperatorName: subOperatorName,
    onCopyOfferURL: onCopyOfferURL
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)(_styles.default.item, _styles.default.buttons)
  }, shouldRenderBasketButton && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)(_styles.default.buttonWrapper, _styles.default.cartsWrapper)
  }, /*#__PURE__*/_react.default.createElement(_BasketButtons.default, {
    offerID: offerID,
    height: _Button.HEIGHTS.FLUID,
    theme: _Button.THEMES.GRAY,
    width: _Button.WIDTHS.FLUID,
    queryID: queryID,
    onSuccessSavedOfferToBasket: openedInModalByKey ? onSuccessSavedOfferToBasket : undefined
  }), t('TO_BASKET_BUTTON')), isEnabledSave2Order && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.flexGrow
  }, /*#__PURE__*/_react.default.createElement(_SaveOrderButton.default, {
    width: _Button.WIDTHS.FLUID,
    hotelID: hotelID,
    offerID: offerID,
    queryID: queryID,
    theme: _Button.THEMES.GRAY
  }, t('TO_ORDER_BUTTON'))), /*#__PURE__*/_react.default.createElement(_Dropdown.DropdownControl, {
    className: _styles.default.flexGrow,
    triggerButton: /*#__PURE__*/_react.default.createElement(_Button.default, {
      theme: _Button.THEMES.GRAY,
      width: _Button.WIDTHS.FLUID,
      fontFamily: _Button.FONT_FAMILIES.REGULAR,
      icon: _share.default
    }, t('SHARE_BUTTON'))
  }, /*#__PURE__*/_react.default.createElement(_Dropdown.DropdownControl.Body, {
    title: t('SHARE_BUTTON')
  }, isEnabledCopy2Buffer && /*#__PURE__*/_react.default.createElement(_CopyInfoButton.default, {
    activeTheme: _Button.THEMES.GRAY,
    className: _styles.default.dropdownButton,
    iconClassName: _styles.default.dropdownIcon,
    offerID: offerKey !== null && offerKey !== void 0 ? offerKey : offerID,
    queryID: queryID,
    theme: _Button.THEMES.TRANSPARENT,
    width: _Button.WIDTHS.FLUID,
    fontFamily: _Button.FONT_FAMILIES.REGULAR
  }, t('COPY_TOUR_BUTTON')), isEnabledCopyURL2Buffer && /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: _styles.default.dropdownButton,
    iconClassName: _styles.default.dropdownIcon,
    contentClassName: _styles.default.nowrap,
    icon: _copy.default,
    onClick: onCopyOfferURL,
    theme: _Button.THEMES.TRANSPARENT,
    activeTheme: _Button.THEMES.GRAY,
    width: _Button.WIDTHS.FLUID,
    fontFamily: _Button.FONT_FAMILIES.REGULAR,
    size: _Button.SIZES.MEDIUM
  }, t('COPY_BUTTON_HINT')), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: _styles.default.dropdownButton,
    iconClassName: _styles.default.dropdownIcon,
    contentClassName: _styles.default.nowrap,
    icon: _diez.default,
    theme: _Button.THEMES.TRANSPARENT,
    activeTheme: _Button.THEMES.GRAY,
    width: _Button.WIDTHS.FLUID,
    fontFamily: _Button.FONT_FAMILIES.REGULAR,
    size: _Button.SIZES.MEDIUM,
    onClick: onCopyOfferCode
  }, t('COPY_CODE_BUTTON')), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: _styles.default.dropdownButton,
    iconClassName: _styles.default.dropdownIcon,
    contentClassName: _styles.default.nowrap,
    icon: _newWindow.default,
    onClick: onOpenOffer,
    theme: _Button.THEMES.TRANSPARENT,
    activeTheme: _Button.THEMES.GRAY,
    width: _Button.WIDTHS.FLUID,
    fontFamily: _Button.FONT_FAMILIES.REGULAR,
    size: _Button.SIZES.MEDIUM
  }, t('NEW_WINDOW_BUTTON'))))), isBookingByOwn ? /*#__PURE__*/_react.default.createElement(_BookingButton.BookingButton, {
    offerID: offerID,
    operatorID: operatorID,
    queryID: queryID,
    onClick: handleClickByBookingButton
  }) : /*#__PURE__*/_react.default.createElement(_DefaultBookingButton.DefaultBookingButton, {
    countryID: countryID,
    offerID: offerID
  }), enabledLoginRequest && /*#__PURE__*/_react.default.createElement(_LoginRequestButton.LoginRequestButton, {
    operatorName: operator.name,
    operatorID: operatorID
  }), /*#__PURE__*/_react.default.createElement(_Divider.Divider, {
    className: _styles.default.divider
  }), /*#__PURE__*/_react.default.createElement(_BookingInfoOfReservation.BookingInfoOfReservation, null), /*#__PURE__*/_react.default.createElement(_ScheduleBookingPayments.ScheduleBookingPayments, null), /*#__PURE__*/_react.default.createElement(_OperatorDetails.OperatorDetails, null)));
};
OrderPure.propTypes = {
  additionalPayments: _propTypes.default.array.isRequired,
  countryID: _propTypes.default.number.isRequired,
  currency: _propTypes.default.shape({
    symbol: _propTypes.default.string.isRequired,
    code: _propTypes.default.string.isRequired
  }).isRequired,
  hotelID: _propTypes.default.number.isRequired,
  includes: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  isActualized: _propTypes.default.bool.isRequired,
  isActualLastUpdate: _propTypes.default.bool.isRequired,
  isConnectionFailedWithOperator: _propTypes.default.bool.isRequired,
  isEndActualized: _propTypes.default.bool.isRequired,
  lastUpdateTime: _propTypes.default.string.isRequired,
  offerID: _propTypes.default.string.isRequired,
  offerKey: _propTypes.default.string,
  price: _propTypes.default.number,
  queryID: _propTypes.default.string.isRequired,
  actualizedAdditionalPayments: _propTypes.default.array,
  actualizedIsHeightPromo: _propTypes.default.bool,
  actualizedPrice: _propTypes.default.number,
  actualizedPromoText: _propTypes.default.string,
  isHeightPromo: _propTypes.default.bool,
  message: _propTypes.default.string,
  operator: _propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    logo: _propTypes.default.string.isRequired
  }),
  promoText: _propTypes.default.string,
  subOperatorName: _propTypes.default.string,
  onBooking: _propTypes.default.func
};
var Order = exports.Order = (0, _react.memo)(OrderPure);